<form [formGroup]="form">
  <app-form-control label="Data zwrotu">
    <p-date-picker
      [formControl]="form.controls.restockedAt"
      placeholder="Wybierz datę zwrotu" />
  </app-form-control>

  <app-form-control label="Numer zlecenia dostawy">
    <input
      [formControl]="form.controls.shippingNumber"
      pInputText
      placeholder="Wprowadź numer przesyłki" />
  </app-form-control>

  <app-form-control label="Rodzaj zwrotu">
    <p-select
      [formControl]="form.controls.type"
      [options]="valueOrDefault(typeSelectItems$ | async, [])"
      appPrimengSelect
      [fluid]="true"
      placeholder="Wybierz rodzaj zwrotu" />
  </app-form-control>

  <div class="mb-4">
    <p-fieldset legend="Osoba zwracająca">
      <app-form-control label="Imię i nazwisko">
        <input
          [formControl]="form.controls.person.controls.dignity"
          pInputText
          placeholder="Wprowadź imię i nazwisko" />
      </app-form-control>

      <app-form-control label="Adres e-mail">
        <input
          [formControl]="form.controls.person.controls.email"
          pInputText
          placeholder="Wprowadź adres e-mail" />
      </app-form-control>

      <app-form-control label="Numer telefonu">
        <input
          [formControl]="form.controls.person.controls.phone"
          pInputText
          placeholder="Wprowadź numer telefonu" />
      </app-form-control>
    </p-fieldset>
  </div>

  <div class="rounded-lg border border-gray-200 p-4">
    <p-accordion
      [multiple]="true"
      [value]="activeProductIndex">
      @for (
        productFormGroup of getProductFormGroups();
        track productFormGroup;
        let index = $index, count = $count
      ) {
        <app-warehouse-restock-form-product-panel
          [productFormGroup]="productFormGroup"
          [total]="count"
          [index]="index"
          (removeClickEvent)="handleProductRemoveClick($event)" />
      } @empty {
        <div class="ng-star-inserted mb-2 italic">
          Kliknij przycisk "Dodaj produkt", aby dodać pozycję zwrotu.
        </div>
      }
    </p-accordion>

    <div class="mt-4 flex justify-end">
      <p-button
        (onClick)="handleProductAddClick()"
        appPrimengButton
        label="Dodaj produkt" />
    </div>
  </div>

  <div class="mt-4">
    <app-form-control label="Komentarz">
      <textarea
        [formControl]="form.controls.comment"
        appPrimengTextarea
        pTextarea
        placeholder="Wprowadź komentarz"
        rows="5"></textarea>
    </app-form-control>

    @if (fileUploadVisibility()) {
      <app-warehouse-files-upload [formControl]="form.controls.fileIds" />
    }
  </div>

  <div class="flex justify-end">
    <p-button
      (onClick)="handleSubmitClick()"
      [disabled]="form.invalid"
      appPrimengButton
      label="Zapisz"
      severity="primary"
      type="submit" />
  </div>
</form>
